import WinnerDialog from './winnerDialog.container'

export default WinnerDialog